<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const formattedNumberEl = ref();
    const emit = defineEmits<{
        (e: 'blur', value: number | number): void;
        (e: 'change', value: number | number): void;
    }>();

    const props = withDefaults(
        defineProps<
            FormInputProps & {
                min?: number;
                max?: number;
                step?: number;
            }
        >(),
        {
            min: 0,
            max: 100,
            step: 0.01,
        }
    );
    const inputData: FormInputData = useFormInput(props);

    const focus = () => {
        formattedNumberEl.value.focus();
    };

    defineExpose({ focus });
</script>

<template>
    <FormFormattedNumberInput
        ref="formattedNumberEl"
        :input-name="inputName"
        :label="label"
        :placeholder="placeholder"
        :form="form"
        :model="model"
        :min="min"
        :max="max"
        :step="step"
        :filled-by-ai="filledByAi"
        :size="size"
        :mask="(value) => `${value}%`"
        :unmask="(value) => parseFloat(value.toString().replace('%', ''))"
        :disabled="inputData.props.disabled"
        :select-on-focus="selectOnFocus"
        :without-label="inputData.props.withoutLabel"
        :class-name="inputData.props.className"
        :element-class-name="inputData.props.elementClassName"
        :container-class-name="inputData.props.containerClassName"
        :autofocus="inputData.props.autofocus"
        @blur="emit('blur', $event)"
        @change="emit('change', $event)"
    />
</template>
